export const adminOverview = {
  totalBusinesses: 1436,
  pendingApprovals: 12,
  totalUsers: 2184,
  activeSubscriptions: 742,
  monthlyRevenue: 486500,
  totalViews: 1284000,
  businessChange: 4.8,
  revenueChange: 11.3,
};

export const adminTrend = [
  { label: "Jan", views: 682000, listings: 1180, revenue: 288000 },
  { label: "Feb", views: 712000, listings: 1216, revenue: 301000 },
  { label: "Mar", views: 748000, listings: 1249, revenue: 322000 },
  { label: "Apr", views: 806000, listings: 1298, revenue: 348000 },
  { label: "May", views: 872000, listings: 1330, revenue: 371000 },
  { label: "Jun", views: 941000, listings: 1364, revenue: 398000 },
  { label: "Jul", views: 1024000, listings: 1391, revenue: 421000 },
  { label: "Aug", views: 1108000, listings: 1412, revenue: 447000 },
  { label: "Sep", views: 1196000, listings: 1428, revenue: 468000 },
  { label: "Oct", views: 1284000, listings: 1436, revenue: 486500 },
];

export const adminCategoryStats = [
  { name: "Retail", count: 305 },
  { name: "Restaurants", count: 248 },
  { name: "Healthcare", count: 187 },
  { name: "Home Services", count: 173 },
  { name: "Education", count: 164 },
  { name: "Beauty & Spa", count: 142 },
  { name: "Hotels", count: 132 },
  { name: "Weddings", count: 121 },
];

export const adminRecentActivity = [
  { id: "act-1", icon: "ri-store-2-line", tone: "primary", text: "New business submitted — Coastal Spice Kitchen", meta: "Kodagu (Coorg) · 12 min ago" },
  { id: "act-2", icon: "ri-checkbox-circle-line", tone: "accent", text: "Listing approved — Sujatha Diagnostics & Clinic", meta: "Approved by admin · 40 min ago" },
  { id: "act-3", icon: "ri-vip-crown-line", tone: "primary", text: "Premium plan purchased — Cauvery Grand Hotel", meta: "₹2,499 · 1 hr ago" },
  { id: "act-4", icon: "ri-star-line", tone: "secondary", text: "New 5-star review — Mylari Mane Restaurant", meta: "Sneha Rao · 2 hrs ago" },
  { id: "act-5", icon: "ri-megaphone-line", tone: "primary", text: "Ad campaign scheduled — Diwali storefront banner", meta: "Starts 18 Oct · 3 hrs ago" },
  { id: "act-6", icon: "ri-user-add-line", tone: "accent", text: "New owner registered — greenleafhome.in", meta: "Mysore · 5 hrs ago" },
];

export const adminBusinesses = [
  { id: "abiz-1", name: "Mylari Mane Restaurant", slug: "mylari-mane-restaurant", categoryName: "Restaurants", locationName: "Mysore", owner: "Ramesh Gowda", plan: "Premium", status: "approved", isFeatured: true, isVerified: true, rating: 4.7, reviewCount: 1284, views: 18420, createdAt: "2023-06-14" },
  { id: "abiz-2", name: "Cauvery Grand Hotel", slug: "cauvery-grand-hotel", categoryName: "Hotels", locationName: "Mysore", owner: "Sunil Rao", plan: "Premium", status: "approved", isFeatured: true, isVerified: true, rating: 4.5, reviewCount: 612, views: 11260, createdAt: "2023-09-02" },
  { id: "abiz-3", name: "Sujatha Diagnostics & Clinic", slug: "sujatha-diagnostics-clinic", categoryName: "Healthcare", locationName: "Mysore", owner: "Dr. Sujatha N", plan: "Standard", status: "approved", isFeatured: true, isVerified: true, rating: 4.6, reviewCount: 389, views: 9870, createdAt: "2024-01-21" },
  { id: "abiz-4", name: "Akshara Academy Coaching", slug: "akshara-academy-coaching", categoryName: "Education", locationName: "Mysore", owner: "Nagaraj P", plan: "Standard", status: "approved", isFeatured: false, isVerified: true, rating: 4.8, reviewCount: 254, views: 7630, createdAt: "2024-03-11" },
  { id: "abiz-5", name: "Sthree Studio Wedding Photography", slug: "sthree-studio-wedding-photography", categoryName: "Weddings", locationName: "Mandya", owner: "Deepa S", plan: "Premium", status: "approved", isFeatured: true, isVerified: true, rating: 4.9, reviewCount: 341, views: 10480, createdAt: "2024-02-08" },
  { id: "abiz-6", name: "Coorg Coffee Trails Homestay", slug: "coorg-coffee-trails-homestay", categoryName: "Travel", locationName: "Kodagu (Coorg)", owner: "Ponnappa M", plan: "Standard", status: "approved", isFeatured: true, isVerified: true, rating: 4.8, reviewCount: 176, views: 6410, createdAt: "2024-05-19" },
  { id: "abiz-7", name: "GreenLeaf Home Services", slug: "greenleaf-home-services", categoryName: "Home Services", locationName: "Mysore", owner: "Imran Khan", plan: "Standard", status: "approved", isFeatured: true, isVerified: true, rating: 4.5, reviewCount: 287, views: 9240, createdAt: "2024-07-30" },
  { id: "abiz-8", name: "Vidyaranya PU College", slug: "vidyaranya-pu-college", categoryName: "Education", locationName: "Mysore", owner: "Girish K", plan: "Free", status: "pending", isFeatured: false, isVerified: false, rating: 4.4, reviewCount: 96, views: 2180, createdAt: "2026-10-07" },
  { id: "abiz-9", name: "Mylari Mane Cloud Kitchen", slug: "mylari-mane-cloud-kitchen", categoryName: "Restaurants", locationName: "Mysore", owner: "Ramesh Gowda", plan: "Free", status: "pending", isFeatured: false, isVerified: false, rating: 0, reviewCount: 0, views: 0, createdAt: "2026-10-09" },
  { id: "abiz-10", name: "Coastal Spice Kitchen", slug: "coastal-spice-kitchen", categoryName: "Restaurants", locationName: "Kodagu (Coorg)", owner: "Lokesh B", plan: "Free", status: "pending", isFeatured: false, isVerified: false, rating: 4.6, reviewCount: 211, views: 3420, createdAt: "2026-10-10" },
  { id: "abiz-11", name: "Sri Lakshmi Gold Palace", slug: "sri-lakshmi-gold-palace", categoryName: "Retail", locationName: "Mysore", owner: "Mahesh Jain", plan: "Standard", status: "approved", isFeatured: false, isVerified: true, rating: 4.6, reviewCount: 420, views: 8760, createdAt: "2023-11-27" },
  { id: "abiz-12", name: "Chamundi Motors Service", slug: "chamundi-motors-service", categoryName: "Automobile", locationName: "Mysore", owner: "Ravi Shankar", plan: "Free", status: "rejected", isFeatured: false, isVerified: false, rating: 4.4, reviewCount: 198, views: 4520, createdAt: "2024-04-15" },
];

export const pendingApprovals = [
  { id: "apr-1", name: "Vidyaranya PU College", slug: "vidyaranya-pu-college", categoryName: "Education", locationName: "Mysore", owner: "Girish K", submittedAt: "2026-10-07", phone: "+91 81235 84816" },
  { id: "apr-2", name: "Mylari Mane Cloud Kitchen", slug: "mylari-mane-cloud-kitchen", categoryName: "Restaurants", locationName: "Mysore", owner: "Ramesh Gowda", submittedAt: "2026-10-09", phone: "+91 81235 84806" },
  { id: "apr-3", name: "Coastal Spice Kitchen", slug: "coastal-spice-kitchen", categoryName: "Restaurants", locationName: "Kodagu (Coorg)", owner: "Lokesh B", submittedAt: "2026-10-10", phone: "+91 81235 84817" },
  { id: "apr-4", name: "Mysore Handicraft Emporium", slug: "mysore-handicraft-emporium", categoryName: "Retail", locationName: "Mysore", owner: "Kavitha R", submittedAt: "2026-10-10", phone: "+91 81235 84820" },
  { id: "apr-5", name: "Riverside Ayurveda Retreat", slug: "riverside-ayurveda-retreat", categoryName: "Beauty & Spa", locationName: "Kodagu (Coorg)", owner: "Anand K", submittedAt: "2026-10-11", phone: "+91 81235 84821" },
];

export const adminUsers = [
  { id: "usr-1", name: "Ramesh Gowda", email: "owner@mysoreyellowpages.com", phone: "+91 81235 84806", role: "owner", listings: 2, plan: "Premium", status: "active", joinedAt: "2023-04-18" },
  { id: "usr-2", name: "Sunil Rao", email: "sunil@cauverygrand.in", phone: "+91 81235 84807", role: "owner", listings: 1, plan: "Premium", status: "active", joinedAt: "2023-09-02" },
  { id: "usr-3", name: "Dr. Sujatha N", email: "care@sujathadiagnostics.in", phone: "+91 81235 84808", role: "owner", listings: 1, plan: "Standard", status: "active", joinedAt: "2024-01-21" },
  { id: "usr-4", name: "Imran Khan", email: "book@greenleafhome.in", phone: "+91 81235 84815", role: "owner", listings: 1, plan: "Standard", status: "active", joinedAt: "2024-07-30" },
  { id: "usr-5", name: "Deepa S", email: "book@sthreestudio.in", phone: "+91 81235 84811", role: "owner", listings: 1, plan: "Premium", status: "active", joinedAt: "2024-02-08" },
  { id: "usr-6", name: "Girish K", email: "office@vidyaranyapu.in", phone: "+91 81235 84816", role: "owner", listings: 1, plan: "Free", status: "pending", joinedAt: "2026-10-07" },
  { id: "usr-7", name: "Mahesh Jain", email: "sales@lakshmigold.in", phone: "+91 81235 84813", role: "owner", listings: 1, plan: "Standard", status: "active", joinedAt: "2023-11-27" },
  { id: "usr-8", name: "Admin Console", email: "admin@mysoreyellowpages.com", phone: "+91 81235 84800", role: "admin", listings: 0, plan: "—", status: "active", joinedAt: "2023-01-05" },
  { id: "usr-9", name: "Ravi Shankar", email: "service@chamundimotors.in", phone: "+91 81235 84810", role: "owner", listings: 1, plan: "Free", status: "suspended", joinedAt: "2024-04-15" },
  { id: "usr-10", name: "Priya Sharma", email: "staff@mysoreyellowpages.com", phone: "+91 81235 84801", role: "staff", listings: 0, plan: "—", status: "active", joinedAt: "2023-03-12" },
];

export const adminLeads = [
  { id: "lead-1", name: "Divya Ramesh", email: "divya.ramesh@gmail.com", phone: "+91 90000 11223", company: "Event planner enquiry", source: "Business profile", status: "new", tag: "Wedding", notes: "Looking for a mandapam in Mysore for December.", createdAt: "2026-10-11" },
  { id: "lead-2", name: "Harish Babu", email: "harish.babu@outlook.com", phone: "+91 90000 44556", company: "Car service", source: "Directory search", status: "contacted", tag: "Automobile", notes: "Requested a callback for doorstep pickup.", createdAt: "2026-10-10" },
  { id: "lead-3", name: "Meera Nair", email: "meera.nair@gmail.com", phone: "+91 90000 77889", company: "Homestay booking", source: "Tourist spots", status: "qualified", tag: "Travel", notes: "Family of four, Coorg in late October.", createdAt: "2026-10-09" },
  { id: "lead-4", name: "Sanjay Kulkarni", email: "sanjay.k@yahoo.com", phone: "+91 90000 33445", company: "NEET coaching", source: "Category page", status: "won", tag: "Education", notes: "Enrolled his daughter at Akshara Academy.", createdAt: "2026-10-05" },
  { id: "lead-5", name: "Priyanka Shetty", email: "priyanka.s@gmail.com", phone: "+91 90000 66778", company: "Jewellery purchase", source: "Featured listings", status: "new", tag: "Shopping", notes: "Asked for making-charge details.", createdAt: "2026-10-11" },
  { id: "lead-6", name: "Arun Prasad", email: "arun.prasad@gmail.com", phone: "+91 90000 99001", company: "Diagnostics", source: "Business profile", status: "lost", tag: "Healthcare", notes: "Chose a different lab closer to home.", createdAt: "2026-10-02" },
];

export const adminOrders = [
  { id: "ao-1", orderNo: "MYP-1024", customer: "Ramesh Gowda", planName: "Premium — Annual", amount: 2499, status: "paid", createdAt: "2026-04-18" },
  { id: "ao-2", orderNo: "MYP-1108", customer: "Nagaraj P", planName: "Standard — Annual", amount: 999, status: "paid", createdAt: "2026-05-02" },
  { id: "ao-3", orderNo: "MYP-1187", customer: "Ramesh Gowda", planName: "Premium — Photos add-on", amount: 600, status: "paid", createdAt: "2026-06-14" },
  { id: "ao-4", orderNo: "MYP-1240", customer: "Sunil Rao", planName: "Homepage feature — 30 days", amount: 1500, status: "pending", createdAt: "2026-09-27" },
  { id: "ao-5", orderNo: "MYP-1265", customer: "Imran Khan", planName: "Standard — Annual", amount: 999, status: "paid", createdAt: "2026-08-11" },
  { id: "ao-6", orderNo: "MYP-1298", customer: "Deepa S", planName: "Banner ad credit", amount: 800, status: "refunded", createdAt: "2026-07-30" },
  { id: "ao-7", orderNo: "MYP-1332", customer: "Ponnappa M", planName: "Elite — Annual", amount: 5999, status: "paid", createdAt: "2026-09-05" },
  { id: "ao-8", orderNo: "MYP-1377", customer: "Mahesh Jain", planName: "Standard — Annual", amount: 999, status: "failed", createdAt: "2026-10-01" },
];

export const adminInvoices = [
  { id: "inv-1", number: "INV-2026-1024", contactName: "Ramesh Gowda", contactEmail: "owner@mysoreyellowpages.com", orderNo: "MYP-1024", amount: 2499, tax: 449, status: "paid", issuedAt: "2026-04-18", dueAt: "2026-05-02", items: [{ description: "Premium annual listing — Mylari Mane Restaurant", qty: 1, rate: 2499 }] },
  { id: "inv-2", number: "INV-2026-1108", contactName: "Nagaraj P", contactEmail: "admissions@aksharaacademy.in", orderNo: "MYP-1108", amount: 999, tax: 179, status: "paid", issuedAt: "2026-05-02", dueAt: "2026-05-16", items: [{ description: "Standard annual listing — Akshara Academy", qty: 1, rate: 999 }] },
  { id: "inv-3", number: "INV-2026-1240", contactName: "Sunil Rao", contactEmail: "sunil@cauverygrand.in", orderNo: "MYP-1240", amount: 1500, tax: 270, status: "unpaid", issuedAt: "2026-09-27", dueAt: "2026-10-11", items: [{ description: "Homepage featured slot — 30 days", qty: 1, rate: 1500 }] },
  { id: "inv-4", number: "INV-2026-1332", contactName: "Ponnappa M", contactEmail: "stay@coffeetrails.in", orderNo: "MYP-1332", amount: 5999, tax: 1079, status: "paid", issuedAt: "2026-09-05", dueAt: "2026-09-19", items: [{ description: "Elite annual listing — Coorg Coffee Trails", qty: 1, rate: 5999 }] },
  { id: "inv-5", number: "INV-2026-1377", contactName: "Mahesh Jain", contactEmail: "sales@lakshmigold.in", orderNo: "MYP-1377", amount: 999, tax: 179, status: "overdue", issuedAt: "2026-10-01", dueAt: "2026-10-08", items: [{ description: "Standard annual renewal — Sri Lakshmi Gold Palace", qty: 1, rate: 999 }] },
  { id: "inv-6", number: "INV-2026-1401", contactName: "Imran Khan", contactEmail: "book@greenleafhome.in", orderNo: "MYP-1401", amount: 1200, tax: 216, status: "draft", issuedAt: "2026-10-10", dueAt: "2026-10-24", items: [{ description: "Deep-clean crew banner ad — 15 days", qty: 1, rate: 1200 }] },
];

export const adminContacts = [
  { id: "con-1", name: "Divya Ramesh", email: "divya.ramesh@gmail.com", phone: "+91 90000 11223", company: "Self", source: "Business profile", status: "new", tag: "Wedding", notes: "Mandapam enquiry for December.", createdAt: "2026-10-11" },
  { id: "con-2", name: "Harish Babu", email: "harish.babu@outlook.com", phone: "+91 90000 44556", company: "Self", source: "Directory search", status: "contacted", tag: "Automobile", notes: "Doorstep car pickup callback.", createdAt: "2026-10-10" },
  { id: "con-3", name: "Meera Nair", email: "meera.nair@gmail.com", phone: "+91 90000 77889", company: "Nair Family", source: "Tourist spots", status: "qualified", tag: "Travel", notes: "Coorg homestay for four.", createdAt: "2026-10-09" },
  { id: "con-4", name: "Sunil Rao", email: "sunil@cauverygrand.in", phone: "+91 81235 84807", company: "Cauvery Grand Hotel", source: "Owner portal", status: "won", tag: "Premium", notes: "Upgraded to Premium annual.", createdAt: "2026-09-27" },
  { id: "con-5", name: "Ponnappa M", email: "stay@coffeetrails.in", phone: "+91 81235 84812", company: "Coorg Coffee Trails", source: "Owner portal", status: "won", tag: "Elite", notes: "Purchased Elite annual plan.", createdAt: "2026-09-05" },
  { id: "con-6", name: "Kavitha R", email: "kavitha.handicraft@gmail.com", phone: "+91 90000 55667", company: "Mysore Handicraft Emporium", source: "List your business", status: "contacted", tag: "Retail", notes: "Awaiting documents for listing approval.", createdAt: "2026-10-10" },
];

export const advertisements = [
  { id: "ad-1", title: "Diwali Storefront Banner", advertiser: "Sri Lakshmi Gold Palace", placement: "Homepage — Hero strip", status: "scheduled", startAt: "2026-10-18", endAt: "2026-11-05", impressions: 0, clicks: 0 },
  { id: "ad-2", title: "Rooftop Dining Promo", advertiser: "Cauvery Grand Hotel", placement: "Category — Hotels", status: "active", startAt: "2026-09-20", endAt: "2026-10-20", impressions: 48210, clicks: 1840 },
  { id: "ad-3", title: "Free Health Checkup Camp", advertiser: "Sujatha Diagnostics & Clinic", placement: "Location — Mysore", status: "active", startAt: "2026-09-01", endAt: "2026-10-31", impressions: 62340, clicks: 2510 },
  { id: "ad-4", title: "Monsoon Home Cleaning Offer", advertiser: "GreenLeaf Home Services", placement: "Sidebar — Directory", status: "paused", startAt: "2026-08-01", endAt: "2026-09-30", impressions: 31900, clicks: 980 },
  { id: "ad-5", title: "Weekend Homestay Getaway", advertiser: "Coorg Coffee Trails Homestay", placement: "Tourist spots — Inline", status: "expired", startAt: "2026-06-01", endAt: "2026-08-31", impressions: 41200, clicks: 1330 },
];

export const adPlacements = [
  { id: "place-1", name: "Homepage Hero Strip", slot: "hero_strip", page: "Homepage", size: "1200 × 120", impressions: 128400, status: "active" },
  { id: "place-2", name: "Category Inline", slot: "category_inline", page: "Category pages", size: "970 × 250", impressions: 84200, status: "active" },
  { id: "place-3", name: "Directory Sidebar", slot: "dir_sidebar", page: "Directory", size: "300 × 600", impressions: 61500, status: "active" },
  { id: "place-4", name: "Location Top Banner", slot: "loc_top", page: "Location pages", size: "970 × 90", impressions: 47800, status: "paused" },
  { id: "place-5", name: "Tourist Spots Inline", slot: "spot_inline", page: "Tourist spots", size: "728 × 90", impressions: 33400, status: "active" },
];

export const adminSubscriptions = [
  { id: "sub-1", business: "Mylari Mane Restaurant", owner: "Ramesh Gowda", plan: "Premium", amount: 2499, cycle: "Annual", renewsAt: "2027-04-18", status: "active" },
  { id: "sub-2", business: "Cauvery Grand Hotel", owner: "Sunil Rao", plan: "Premium", amount: 2499, cycle: "Annual", renewsAt: "2027-09-02", status: "active" },
  { id: "sub-3", business: "Akshara Academy Coaching", owner: "Nagaraj P", plan: "Standard", amount: 999, cycle: "Annual", renewsAt: "2027-05-02", status: "active" },
  { id: "sub-4", business: "Coorg Coffee Trails Homestay", owner: "Ponnappa M", plan: "Elite", amount: 5999, cycle: "Annual", renewsAt: "2027-09-05", status: "active" },
  { id: "sub-5", business: "GreenLeaf Home Services", owner: "Imran Khan", plan: "Standard", amount: 999, cycle: "Annual", renewsAt: "2026-10-11", status: "past_due" },
  { id: "sub-6", business: "Sri Lakshmi Gold Palace", owner: "Mahesh Jain", plan: "Standard", amount: 99, cycle: "Monthly", renewsAt: "2026-11-01", status: "active" },
  { id: "sub-7", business: "Sthree Studio Wedding Photography", owner: "Deepa S", plan: "Premium", amount: 2499, cycle: "Annual", renewsAt: "2026-10-30", status: "trialing" },
  { id: "sub-8", business: "Chamundi Motors Service", owner: "Ravi Shankar", plan: "Standard", amount: 999, cycle: "Annual", renewsAt: "2026-09-15", status: "cancelled" },
];

export const adminSubcategories = [
  { id: "subc-1", name: "South Indian", slug: "south-indian", categoryId: "cat-restaurants", categoryName: "Restaurants", businessCount: 96, status: "active" },
  { id: "subc-2", name: "Cafes & Bakeries", slug: "cafes-bakeries", categoryId: "cat-restaurants", categoryName: "Restaurants", businessCount: 71, status: "active" },
  { id: "subc-3", name: "Budget Hotels", slug: "budget-hotels", categoryId: "cat-hotels", categoryName: "Hotels", businessCount: 64, status: "active" },
  { id: "subc-4", name: "Resorts & Homestays", slug: "resorts-homestays", categoryId: "cat-hotels", categoryName: "Hotels", businessCount: 45, status: "active" },
  { id: "subc-5", name: "Diagnostic Labs", slug: "diagnostic-labs", categoryId: "cat-healthcare", categoryName: "Healthcare", businessCount: 58, status: "active" },
  { id: "subc-6", name: "NEET / JEE Coaching", slug: "neet-jee-coaching", categoryId: "cat-education", categoryName: "Education", businessCount: 39, status: "active" },
  { id: "subc-7", name: "Plumbing Services", slug: "plumbing-services", categoryId: "cat-homeservices", categoryName: "Home Services", businessCount: 52, status: "active" },
  { id: "subc-8", name: "Bridal Makeup", slug: "bridal-makeup", categoryId: "cat-beauty", categoryName: "Beauty & Spa", businessCount: 28, status: "hidden" },
];

export const adminSeoSettings = {
  metaTitle: "Mysore Yellow Pages — Local Business Directory",
  metaDescription: "Discover trusted local businesses, services and tourist spots across Mysore, Mandya, Chamarajanagar and Kodagu.",
  keywords: "mysore business directory, local services mysore, tourist spots mysore, mandya businesses, coorg homestays",
  canonical: "https://www.mysoreyellowpages.com",
  robots: "index, follow",
  sitemapEnabled: true,
  gscVerified: true,
};

export const adminSystemSettings = {
  siteName: "Mysore Yellow Pages",
  supportEmail: "mysoreyellowpages@gmail.com",
  supportPhone: "+91 81235 84806",
  currency: "INR (₹)",
  timezone: "Asia/Kolkata (IST)",
  autoApproveListings: false,
  reviewsModeration: true,
  maintenanceMode: false,
};

export const adminDemoAccount = { name: "Administrator", email: "admin@mysoreyellowpages.com", password: "demo1234" };
export const staffDemoAccount = { name: "Priya Sharma", email: "staff@mysoreyellowpages.com", password: "demo1234" };

// Full editable records for the admin business editor, keyed by the same ids
// as `adminBusinesses`. The first gallery photo is always the cover image.
export const adminBusinessDetails = [
  {
    id: "abiz-1",
    name: "Mylari Mane Restaurant",
    slug: "mylari-mane-restaurant",
    categoryName: "Restaurants",
    locationName: "Mysore",
    owner: "Ramesh Gowda",
    plan: "Premium",
    status: "approved",
    isFeatured: true,
    isVerified: true,
    rating: 4.7,
    reviewCount: 1284,
    views: 18420,
    createdAt: "2023-06-14",
    description:
      "Authentic Mysore-style benne dosa, idli and filter coffee served fresh since 1978. A local breakfast institution a short walk from Sayyaji Rao Road.",
    address: "Sayyaji Rao Road, Mysore, Karnataka 570001",
    phone: "+91 81235 84806",
    email: "hello@mylarimane.in",
    website: "https://mylarimane.in",
    hours: "6:30 AM - 10:00 PM",
    gallery: [
      { id: "ph-1-1", url: "https://readdy.ai/api/search-image?query=Warm%20crispy%20Mysore%20masala%20dosa%20on%20a%20banana%20leaf%20with%20coconut%20chutney%20and%20filter%20coffee%2C%20rustic%20wooden%20table%2C%20soft%20natural%20light%2C%20appetizing%20food%20photography%2C%20warm%20tones&width=800&height=600&seq=myyp-biz-1&orientation=landscape", caption: "Signature benne dosa" },
      { id: "ph-1-2", url: "https://readdy.ai/api/search-image?query=Close%20up%20of%20filter%20coffee%20being%20poured%20into%20a%20steel%20tumbler%20at%20a%20traditional%20Indian%20restaurant%2C%20warm%20steam%20and%20golden%20light%2C%20food%20photography&width=800&height=600&seq=myyp-owner-media-6&orientation=landscape", caption: "Filter coffee" },
      { id: "ph-1-3", url: "https://readdy.ai/api/search-image?query=Warm%20inviting%20South%20Indian%20vegetarian%20restaurant%20interior%20with%20wooden%20tables%20brass%20lamps%20and%20a%20fresh%20dosa%20platter%2C%20soft%20golden%20lighting%2C%20clean%20simple%20background%2C%20appetizing%20editorial%20food%20photography&width=800&height=600&seq=myyp-biz-13&orientation=landscape", caption: "Dining hall" },
    ],
  },
  {
    id: "abiz-2",
    name: "Cauvery Grand Hotel",
    slug: "cauvery-grand-hotel",
    categoryName: "Hotels",
    locationName: "Mysore",
    owner: "Sunil Rao",
    plan: "Premium",
    status: "approved",
    isFeatured: true,
    isVerified: true,
    rating: 4.5,
    reviewCount: 612,
    views: 11260,
    createdAt: "2023-09-02",
    description:
      "Boutique business hotel two kilometres from Mysore Palace with rooftop dining, conference halls and 42 well-appointed rooms.",
    address: "Bannur Road, Mysore, Karnataka 570011",
    phone: "+91 81235 84807",
    email: "reservations@cauverygrand.in",
    website: "https://cauverygrand.in",
    hours: "24 hours",
    gallery: [
      { id: "ph-2-1", url: "https://readdy.ai/api/search-image?query=Elegant%20boutique%20hotel%20lobby%20with%20warm%20wood%20panels%2C%20brass%20lamps%20and%20marble%20floor%2C%20hospitality%20interior%20photography%2C%20amber%20and%20cream%20tones&width=800&height=600&seq=myyp-biz-2&orientation=landscape", caption: "Lobby" },
      { id: "ph-2-2", url: "https://readdy.ai/api/search-image?query=Contemporary%20boutique%20hotel%20room%20with%20warm%20wood%20furniture%20crisp%20linens%20and%20soft%20evening%20lamp%20light%2C%20clean%20minimal%20background%2C%20elegant%20hospitality%20interior%20photography&width=800&height=600&seq=myyp-biz-17&orientation=landscape", caption: "Deluxe room" },
    ],
  },
  {
    id: "abiz-3",
    name: "Sujatha Diagnostics & Clinic",
    slug: "sujatha-diagnostics-clinic",
    categoryName: "Healthcare",
    locationName: "Mysore",
    owner: "Dr. Sujatha N",
    plan: "Standard",
    status: "approved",
    isFeatured: true,
    isVerified: true,
    rating: 4.6,
    reviewCount: 389,
    views: 9870,
    createdAt: "2024-01-21",
    description:
      "NABL-accredited pathology lab and multispeciality clinic offering home sample collection across Mysore with same-day reports.",
    address: "Vijayanagar 2nd Stage, Mysore, Karnataka 570017",
    phone: "+91 81235 84808",
    email: "care@sujathadiagnostics.in",
    website: "",
    hours: "7:00 AM - 9:00 PM",
    gallery: [
      { id: "ph-3-1", url: "https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20diagnostics%20lab%20interior%20with%20bright%20white%20surfaces%20and%20warm%20green%20accents%2C%20clinical%20healthcare%20photography%2C%20calm%20and%20professional&width=800&height=600&seq=myyp-biz-3&orientation=landscape", caption: "Diagnostics lab" },
      { id: "ph-3-2", url: "https://readdy.ai/api/search-image?query=Calm%20modern%20multispeciality%20clinic%20reception%20with%20warm%20wooden%20accents%20indoor%20plants%20and%20soft%20natural%20light%2C%20clean%20simple%20background%2C%20welcoming%20healthcare%20interior%20photography&width=800&height=600&seq=myyp-biz-16&orientation=landscape", caption: "Clinic reception" },
    ],
  },
  {
    id: "abiz-4",
    name: "Akshara Academy Coaching",
    slug: "akshara-academy-coaching",
    categoryName: "Education",
    locationName: "Mysore",
    owner: "Nagaraj P",
    plan: "Standard",
    status: "approved",
    isFeatured: false,
    isVerified: true,
    rating: 4.8,
    reviewCount: 254,
    views: 7630,
    createdAt: "2024-03-11",
    description:
      "NEET, JEE and PU coaching with small batches, weekly mock tests and personal mentoring by experienced faculty.",
    address: "Kuvempunagar, Mysore, Karnataka 570023",
    phone: "+91 81235 84809",
    email: "admissions@aksharaacademy.in",
    website: "https://aksharaacademy.in",
    hours: "8:00 AM - 8:00 PM",
    gallery: [
      { id: "ph-4-1", url: "https://readdy.ai/api/search-image?query=Bright%20modern%20coaching%20classroom%20with%20wooden%20desks%2C%20green%20chalkboard%20and%20large%20windows%2C%20warm%20daylight%2C%20education%20photography&width=800&height=600&seq=myyp-biz-4&orientation=landscape", caption: "Classroom" },
      { id: "ph-4-2", url: "https://readdy.ai/api/search-image?query=Colonial%20style%20college%20building%20with%20red%20tiles%20and%20green%20campus%20lawn%20in%20Mysore%2C%20warm%20afternoon%20light%2C%20architectural%20photography&width=800&height=600&seq=myyp-biz-11&orientation=landscape", caption: "Campus" },
    ],
  },
  {
    id: "abiz-5",
    name: "Sthree Studio Wedding Photography",
    slug: "sthree-studio-wedding-photography",
    categoryName: "Weddings",
    locationName: "Mandya",
    owner: "Deepa S",
    plan: "Premium",
    status: "approved",
    isFeatured: true,
    isVerified: true,
    rating: 4.9,
    reviewCount: 341,
    views: 10480,
    createdAt: "2024-02-08",
    description:
      "Candid wedding photography, cinematography and pre-wedding shoots across Mysore and Mandya, with a dedicated two-member crew.",
    address: "Bengaluru-Mysore Road, Mandya, Karnataka 571401",
    phone: "+91 81235 84811",
    email: "book@sthreestudio.in",
    website: "https://sthreestudio.in",
    hours: "By appointment",
    gallery: [
      { id: "ph-5-1", url: "https://readdy.ai/api/search-image?query=Candid%20South%20Indian%20wedding%20moment%20with%20warm%20bokeh%20lights%20and%20floral%20decor%2C%20cinematic%20photography%2C%20golden%20and%20maroon%20tones&width=800&height=600&seq=myyp-biz-6&orientation=landscape", caption: "Wedding candid" },
      { id: "ph-5-2", url: "https://readdy.ai/api/search-image?query=Romantic%20editorial%20photograph%20of%20a%20wedding%20camera%20resting%20on%20draped%20fabric%20with%20marigold%20flowers%20and%20brass%20lamps%2C%20soft%20warm%20light%2C%20simple%20cream%20and%20gold%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=800&height=600&seq=popcat-wedding-011&orientation=landscape", caption: "Behind the scenes" },
    ],
  },
  {
    id: "abiz-6",
    name: "Coorg Coffee Trails Homestay",
    slug: "coorg-coffee-trails-homestay",
    categoryName: "Travel",
    locationName: "Kodagu (Coorg)",
    owner: "Ponnappa M",
    plan: "Standard",
    status: "approved",
    isFeatured: true,
    isVerified: true,
    rating: 4.8,
    reviewCount: 176,
    views: 6410,
    createdAt: "2024-05-19",
    description:
      "A working coffee plantation homestay offering guided estate walks, home-style Kodava meals and bonfire evenings in the Coorg hills.",
    address: "Madikeri, Kodagu, Karnataka 571201",
    phone: "+91 81235 84812",
    email: "stay@coffeetrails.in",
    website: "https://coffeetrails.in",
    hours: "Check-in 1:00 PM",
    gallery: [
      { id: "ph-6-1", url: "https://readdy.ai/api/search-image?query=Cozy%20plantation%20homestay%20veranda%20overlooking%20coffee%20hills%20in%20Coorg%2C%20wooden%20chairs%20and%20lanterns%2C%20misty%20green%20morning%2C%20warm%20inviting%20travel%20photography&width=800&height=600&seq=myyp-biz-7&orientation=landscape", caption: "Veranda view" },
      { id: "ph-6-2", url: "https://readdy.ai/api/search-image?query=Misty%20green%20coffee%20plantation%20rows%20on%20a%20Coorg%20hillside%20at%20sunrise%2C%20soft%20golden%20light%20through%20the%20leaves%2C%20calm%20travel%20photography&width=800&height=600&seq=myyp-spot-7&orientation=landscape", caption: "Coffee estate" },
    ],
  },
  {
    id: "abiz-7",
    name: "GreenLeaf Home Services",
    slug: "greenleaf-home-services",
    categoryName: "Home Services",
    locationName: "Mysore",
    owner: "Imran Khan",
    plan: "Standard",
    status: "approved",
    isFeatured: true,
    isVerified: true,
    rating: 4.5,
    reviewCount: 287,
    views: 9240,
    createdAt: "2024-07-30",
    description:
      "Verified electricians, plumbers, carpenters and deep-cleaning crews on call across Mysore city, with upfront hourly pricing.",
    address: "Ramanuja Road, Mysore, Karnataka 570004",
    phone: "+91 81235 84815",
    email: "book@greenleafhome.in",
    website: "https://greenleafhome.in",
    hours: "8:00 AM - 9:00 PM",
    gallery: [
      { id: "ph-7-1", url: "https://readdy.ai/api/search-image?query=Friendly%20home%20service%20technician%20in%20uniform%20with%20toolkit%20at%20a%20bright%20doorway%2C%20trustworthy%20warm%20editorial%20photography%2C%20cream%20and%20green%20tones&width=800&height=600&seq=myyp-biz-10&orientation=landscape", caption: "Service team" },
      { id: "ph-7-2", url: "https://readdy.ai/api/search-image?query=Practical%20editorial%20photograph%20of%20plumbing%20tools%20with%20pipes%2C%20a%20wrench%20and%20fittings%20on%20a%20light%20surface%2C%20soft%20light%2C%20simple%20cream%20and%20warm%20grey%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=800&height=600&seq=popcat-plumber-012&orientation=landscape", caption: "Tools" },
    ],
  },
  {
    id: "abiz-8",
    name: "Vidyaranya PU College",
    slug: "vidyaranya-pu-college",
    categoryName: "Education",
    locationName: "Mysore",
    owner: "Girish K",
    plan: "Free",
    status: "pending",
    isFeatured: false,
    isVerified: false,
    rating: 4.4,
    reviewCount: 96,
    views: 2180,
    createdAt: "2026-10-07",
    description:
      "Pre-university college for Science and Commerce streams with a strong academic record and active placement guidance.",
    address: "Gangotri Layout, Mysore, Karnataka 570009",
    phone: "+91 81235 84816",
    email: "office@vidyaranyapu.in",
    website: "",
    hours: "8:30 AM - 4:30 PM",
    gallery: [
      { id: "ph-8-1", url: "https://readdy.ai/api/search-image?query=Colonial%20style%20college%20building%20with%20red%20tiles%20and%20green%20campus%20lawn%20in%20Mysore%2C%20warm%20afternoon%20light%2C%20architectural%20photography&width=800&height=600&seq=myyp-biz-11&orientation=landscape", caption: "College building" },
    ],
  },
  {
    id: "abiz-9",
    name: "Mylari Mane Cloud Kitchen",
    slug: "mylari-mane-cloud-kitchen",
    categoryName: "Restaurants",
    locationName: "Mysore",
    owner: "Ramesh Gowda",
    plan: "Free",
    status: "pending",
    isFeatured: false,
    isVerified: false,
    rating: 0,
    reviewCount: 0,
    views: 0,
    createdAt: "2026-10-09",
    description:
      "A delivery-only extension of Mylari Mane serving the same benne dosa, idli and filter coffee across Mysore through food apps.",
    address: "Sayyaji Rao Road, Mysore, Karnataka 570001",
    phone: "+91 81235 84806",
    email: "orders@mylarimane.in",
    website: "",
    hours: "7:00 AM - 9:00 PM",
    gallery: [
      { id: "ph-9-1", url: "https://readdy.ai/api/search-image?query=Neat%20takeaway%20food%20packaging%20with%20South%20Indian%20breakfast%20items%20on%20a%20warm%20wooden%20surface%2C%20clean%20appetizing%20food%20photography%2C%20amber%20tones&width=800&height=600&seq=myyp-biz-13&orientation=landscape", caption: "Takeaway packing" },
    ],
  },
  {
    id: "abiz-10",
    name: "Coastal Spice Kitchen",
    slug: "coastal-spice-kitchen",
    categoryName: "Restaurants",
    locationName: "Kodagu (Coorg)",
    owner: "Lokesh B",
    plan: "Free",
    status: "pending",
    isFeatured: false,
    isVerified: false,
    rating: 4.6,
    reviewCount: 211,
    views: 3420,
    createdAt: "2026-10-10",
    description:
      "Kodava and coastal specialities — pandi curry, kadambuttu and akki roti served in a rustic family-run setting.",
    address: "Kushalnagar, Kodagu, Karnataka 571234",
    phone: "+91 81235 84817",
    email: "hello@coastalspice.in",
    website: "",
    hours: "11:30 AM - 10:30 PM",
    gallery: [
      { id: "ph-10-1", url: "https://readdy.ai/api/search-image?query=Rustic%20Kodava%20meal%20spread%20with%20curry%20and%20rice%20dumplings%20on%20dark%20wooden%20table%2C%20warm%20moody%20food%20photography%2C%20spice%20and%20amber%20tones&width=800&height=600&seq=myyp-biz-12&orientation=landscape", caption: "Kodava thali" },
    ],
  },
  {
    id: "abiz-11",
    name: "Sri Lakshmi Gold Palace",
    slug: "sri-lakshmi-gold-palace",
    categoryName: "Retail",
    locationName: "Mysore",
    owner: "Mahesh Jain",
    plan: "Standard",
    status: "approved",
    isFeatured: false,
    isVerified: true,
    rating: 4.6,
    reviewCount: 420,
    views: 8760,
    createdAt: "2023-11-27",
    description:
      "Trusted BIS-hallmarked gold, silver and diamond jewellery with transparent making charges and lifetime exchange.",
    address: "Dhanvantri Road, Mysore, Karnataka 570001",
    phone: "+91 81235 84813",
    email: "sales@lakshmigold.in",
    website: "",
    hours: "10:00 AM - 8:30 PM",
    gallery: [
      { id: "ph-11-1", url: "https://readdy.ai/api/search-image?query=Elegant%20gold%20jewellery%20display%20on%20warm%20velvet%20with%20soft%20studio%20lighting%2C%20necklace%20and%20bangles%2C%20luxury%20retail%20photography%2C%20golden%20tones&width=800&height=600&seq=myyp-biz-8&orientation=landscape", caption: "Gold collection" },
      { id: "ph-11-2", url: "https://readdy.ai/api/search-image?query=Colourful%20traditional%20silk%20saree%20showroom%20with%20neatly%20folded%20stacked%20fabrics%20on%20warm%20wooden%20shelves%2C%20soft%20inviting%20lighting%2C%20simple%20background%2C%20Indian%20retail%20photography&width=800&height=600&seq=myyp-biz-18&orientation=landscape", caption: "Showroom" },
    ],
  },
  {
    id: "abiz-12",
    name: "Chamundi Motors Service",
    slug: "chamundi-motors-service",
    categoryName: "Automobile",
    locationName: "Mysore",
    owner: "Ravi Shankar",
    plan: "Free",
    status: "rejected",
    isFeatured: false,
    isVerified: false,
    rating: 4.4,
    reviewCount: 198,
    views: 4520,
    createdAt: "2024-04-15",
    description:
      "Multi-brand car service centre offering periodic service, denting-painting, wheel alignment and genuine spares with doorstep pickup.",
    address: "Hebbal Industrial Area, Mysore, Karnataka 570016",
    phone: "+91 81235 84810",
    email: "service@chamundimotors.in",
    website: "",
    hours: "9:00 AM - 7:00 PM",
    gallery: [
      { id: "ph-12-1", url: "https://readdy.ai/api/search-image?query=Organized%20automotive%20service%20garage%20with%20a%20car%20on%20lift%2C%20tools%20and%20warm%20industrial%20lighting%2C%20clean%20professional%20photography&width=800&height=600&seq=myyp-biz-5&orientation=landscape", caption: "Service bay" },
      { id: "ph-12-2", url: "https://readdy.ai/api/search-image?query=Clean%20editorial%20photograph%20of%20a%20bright%20car%20service%20garage%20with%20wrenches%2C%20tools%20and%20a%20lifted%20car%2C%20soft%20overhead%20light%2C%20simple%20cream%20and%20grey%20background%2C%20minimal%20clean%20composition%2C%20high%20detail&width=800&height=600&seq=popcat-auto-002&orientation=landscape", caption: "Workshop" },
    ],
  },
];

export const approvalAuditLog = [
  { id: "audit-1", businessId: "abiz-8", businessName: "Vidyaranya PU College", reviewer: "Admin Console", decision: "rejected", note: "Missing affiliation documents — resubmission requested.", decidedAt: "2026-10-08 11:24" },
  { id: "audit-2", businessId: "abiz-9", businessName: "Mylari Mane Cloud Kitchen", reviewer: "Admin Console", decision: "approved", note: "FSSAI licence verified. Published to Restaurants.", decidedAt: "2026-10-09 16:02" },
  { id: "audit-3", businessId: "abiz-6", businessName: "Coorg Coffee Trails Homestay", reviewer: "Admin Console", decision: "approved", note: "Photos and pricing confirmed. Featured on homepage.", decidedAt: "2026-10-06 09:47" },
  { id: "audit-4", businessId: "abiz-12", businessName: "Chamundi Motors Service", reviewer: "Admin Console", decision: "rejected", note: "Duplicate of an existing accredited service centre.", decidedAt: "2026-10-04 14:18" },
];

// Combined activity / audit trail — every listing and review moderation action
// the console has taken. Mirrors the admin_audit table on the live backend.
export const adminAuditLog = [
  { id: "adm-audit-1", entityType: "review", entityId: "124", entityLabel: "Review by Deepak M", action: "rejected", actor: "Administrator", note: "", createdAt: "2026-10-12 18:40" },
  { id: "adm-audit-2", entityType: "listing", entityId: "abiz-3", entityLabel: "Sujatha Diagnostics & Clinic", action: "approved", actor: "Administrator", note: "Documents verified.", createdAt: "2026-10-12 16:05" },
  { id: "adm-audit-3", entityType: "review", entityId: "121", entityLabel: "Review by Anonymous", action: "deleted", actor: "Priya Sharma", note: "", createdAt: "2026-10-12 11:22" },
  { id: "adm-audit-4", entityType: "listing", entityId: "abiz-8", entityLabel: "Vidyaranya PU College", action: "rejected", actor: "Administrator", note: "Missing affiliation documents — resubmission requested.", createdAt: "2026-10-11 09:47" },
  { id: "adm-audit-5", entityType: "review", entityId: "122", entityLabel: "Review by Freddy D", action: "rejected", actor: "Priya Sharma", note: "", createdAt: "2026-10-10 15:30" },
  { id: "adm-audit-6", entityType: "listing", entityId: "abiz-9", entityLabel: "Mylari Mane Cloud Kitchen", action: "approved", actor: "Administrator", note: "FSSAI licence verified.", createdAt: "2026-10-09 16:02" },
  { id: "adm-audit-7", entityType: "listing", entityId: "abiz-12", entityLabel: "Chamundi Motors Service", action: "suspended", actor: "Administrator", note: "Status set to suspended", createdAt: "2026-10-08 12:10" },
  { id: "adm-audit-8", entityType: "listing", entityId: "abiz-6", entityLabel: "Coorg Coffee Trails Homestay", action: "approved", actor: "Administrator", note: "Photos and pricing confirmed.", createdAt: "2026-10-06 09:47" },
];